
import { motion } from "framer-motion";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  showText?: boolean;
}

export function Logo({ size = "md", showText = true }: LogoProps) {
  const sizes = {
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-14 w-14"
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex items-center gap-2"
    >
      <div className={`${sizes[size]} relative rounded-xl overflow-hidden`}>
        <img 
          src="/lovable-uploads/1e005031-6e6d-4739-84b8-dbd4eb64d0f6.png" 
          alt="Flame Logo" 
          className="w-full h-full object-cover"
        />
      </div>
      {showText && (
        <span className="font-semibold text-lg tracking-tight text-burgundy-dark">Cray Cray Reposters</span>
      )}
    </motion.div>
  );
}
